
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitomatherancab() {



    const cardData =
    {
        keyword: ' Mumbai to Matheran Cab',
        heading: 'Deva Cabs: Mumbai to Matheran Cab',
        headingDescription: 'Deva Cabs provides reliable and affordable cab services from Mumbai to Matheran, perfect for nature lovers, weekend getaways, and peaceful retreats. Located around 85 km from Mumbai, Matheran is a charming hill station known for its vehicle-free zones and scenic beauty. Our cabs drop you comfortably at Dasturi Naka, the entry point to Matheran. Choose from Sedans, SUVs, or Innova Crysta, all driven by courteous professionals. With fixed fares, flexible pickup times, and 24/7 service, Deva Cabs ensures a smooth journey to Matheran.',

        top: 'Top Places to Visit in Matheran with Deva Cabs',

"topPlaces": [
  {
    "title": "Panorama Point",
    "location": "Matheran, Maharashtra",
    "description": "Panorama Point offers a 360-degree view of the surrounding Sahyadri hills and valleys. It’s one of the most scenic viewpoints in Matheran, especially popular for sunrise and sunset watching. The calm environment, cool breeze, and vast landscape make it a favorite among nature lovers and photographers."
  },
  {
    "title": "Charlotte Lake",
    "location": "Matheran, Maharashtra",
    "description": "Charlotte Lake is a tranquil water body nestled amidst dense forest and hills. It serves as a key water source for Matheran and is ideal for picnics, birdwatching, and quiet reflection. The lake is also close to other attractions like Pisarnath Temple and Echo Point."
  },
  {
    "title": "Echo Point",
    "location": "Matheran, Maharashtra",
    "description": "Echo Point is a fun and family-friendly spot where visitors can shout and hear their voices bounce back through the valley. Along with the natural echo phenomenon, it offers panoramic views of the hills and is especially refreshing during monsoon with surrounding waterfalls."
  },
  {
    "title": "Louisa Point",
    "location": "Matheran, Maharashtra",
    "description": "Louisa Point is known for its stunning views of Prabal Fort and Vishalgad. It’s one of the best places in Matheran for photography, offering cliff-side vistas, misty horizons, and deep green valleys. Ideal for quiet contemplation or romantic walks."
  },
  {
    "title": "One Tree Hill Point",
    "location": "Matheran, Maharashtra",
    "description": "This unique hilltop is named after the lone tree standing on it. One Tree Hill Point offers panoramic views and is accessible via a scenic trek. It’s a peaceful and less crowded viewpoint, great for those looking to escape into untouched nature."
  },
  {
    "title": "Porcupine Point (Sunset Point)",
    "location": "Matheran, Maharashtra",
    "description": "Also known as Sunset Point, Porcupine Point provides breathtaking views of the sun dipping below the hills. The surrounding scenery becomes golden during dusk, making it a magical moment for tourists. It’s a must-visit for evening sightseeing in Matheran."
  },
  {
    "title": "Matheran Toy Train",
    "location": "Matheran, Maharashtra",
    "description": "The Matheran Hill Railway offers a nostalgic toy train ride from Neral to Matheran. Winding through the hills and forests, the journey provides scenic views and a relaxing pace. The narrow-gauge heritage train is a memorable experience for kids and adults alike."
  },
  {
    "title": "Honeymoon Hill",
    "location": "Matheran, Maharashtra",
    "description": "Honeymoon Hill is a quiet viewpoint that offers peaceful surroundings and romantic views, hence its name. Surrounded by dense forest and valleys, it’s perfect for couples or anyone seeking solitude amidst nature’s beauty."
  },
  {
    "title": "Alexander Point",
    "location": "Matheran, Maharashtra",
    "description": "Alexander Point provides excellent views of the Palasdari Lake, Borgaon village, and Garbut Point. It’s a peaceful place ideal for morning visits and photography, and less crowded than some of the other major viewpoints in the area."
  },
  {
    "title": "Pisarnath Temple",
    "location": "Matheran, Maharashtra",
    "description": "Located near Charlotte Lake, Pisarnath Temple is the oldest temple in Matheran dedicated to Lord Shiva. Set in a peaceful forest environment, it’s a spiritual retreat surrounded by greenery and adds cultural depth to your Matheran visit."
  }
],



"services": [
  {
    "name": "Mumbai to Matheran Cab",
    "description": "Explore the serene hill station of Matheran with Deva Cabs’ Mumbai to Matheran cab services. Our well-maintained vehicles and experienced chauffeurs ensure a smooth and scenic drive right up to Dasturi Naka — the final point for vehicles before the toy train or horse ride into Matheran. Whether you’re traveling solo, with family, or in a group, our cab options are tailored for a relaxed and safe trip to the hills."
  },
  {
    "name": "Book cab Mumbai to Matheran",
    "description": "Booking a cab from Mumbai to Matheran is quick and easy with Deva Cabs. Our user-friendly system allows you to select your vehicle type, pick-up time, and route preferences online or by phone. Get instant confirmations, transparent fares, and professional service with every booking. Ideal for weekend getaways, short holidays, or family retreats."
  },
  {
    "name": "One-way taxi Mumbai to Matheran",
    "description": "Looking for a one-way drop to Matheran? Deva Cabs offers affordable and convenient one-way taxi services from Mumbai. Whether you're staying overnight or longer, our one-way option is budget-friendly and perfect for travelers not needing a return journey. Enjoy timely pickup, clean vehicles, and courteous drivers."
  },
  {
    "name": "SUV cab hire Mumbai to Matheran",
    "description": "Need more room for your group or luggage? Hire a spacious SUV cab from Mumbai to Matheran. Our SUVs are ideal for families or groups heading into the hills, offering excellent road handling, ample space, and a comfortable ride all the way to Dasturi Naka. Perfect for hilly terrain and long drives."
  },
  {
    "name": "AC cab Mumbai to Matheran",
    "description": "Beat the heat and travel in comfort with Deva Cabs’ fully air-conditioned cabs to Matheran. Our AC cabs ensure a relaxing environment during the drive through winding roads and mountain air. Stay cool and comfortable, whether it’s summer or monsoon season."
  },
  {
    "name": "Mumbai to Matheran sightseeing taxi",
    "description": "Turn your journey into an experience with our Mumbai to Matheran sightseeing taxi. Stop along the way at scenic viewpoints, waterfalls, and local food spots. Our drivers are knowledgeable about the route and can help you plan photo stops and short walks to enjoy the beautiful surroundings."
  },
  {
    "name": "Chauffeur-driven car Mumbai to Matheran",
    "description": "Travel worry-free with our chauffeur-driven car services to Matheran. Our professional drivers are courteous, punctual, and well-versed with hill driving. Let us handle the road while you relax and enjoy the changing landscape from cityscape to lush hills."
  },
  {
    "name": "Online cab booking to Matheran from Mumbai",
    "description": "Book your Matheran cab online in just a few clicks through Deva Cabs. Compare vehicles, check availability, and confirm your trip instantly. Our online booking platform is secure, easy to use, and provides clear pricing with no hidden charges."
  },
  {
    "name": "Round trip cab Mumbai to Matheran",
    "description": "Planning a short trip to Matheran and back? Opt for our round-trip cab service and get the convenience of pickup and drop at your schedule. Ideal for day-trippers or overnight stays, our round trip package includes waiting time and flexible return planning."
  },
  {
    "name": "Affordable Mumbai to Matheran taxi",
    "description": "Deva Cabs offers cost-effective taxi services from Mumbai to Matheran without compromising on comfort or safety. Our budget-friendly options include hatchbacks, sedans, and shared rides, making it easy for anyone to plan a peaceful hill station trip."
  },
  {
    "name": "Luxury cab Mumbai to Matheran",
    "description": "Travel in style with our premium luxury cab options from Mumbai to Matheran. Choose from sedans or SUVs with plush interiors, leather seats, and a smooth, high-end ride — perfect for honeymooners, couples, or anyone seeking a first-class experience."
  },
  {
    "name": "Family cab hire Mumbai to Matheran",
    "description": "Make your family trip to Matheran comfortable and safe with Deva Cabs. Our family cab options offer roomy interiors, safety features, and courteous drivers who are patient and experienced in handling long journeys with kids and elders alike."
  },
  {
    "name": "Premium Matheran cab from Mumbai",
    "description": "Choose our premium cab service for your next trip to Matheran and enjoy top-tier service from start to finish. Deva Cabs offers premium cars with well-dressed chauffeurs, bottled water, music systems, and excellent customer support for a stress-free travel experience."
  },
  {
    "name": "Corporate cab Mumbai to Matheran",
    "description": "Whether it's a business offsite, team retreat, or a formal trip, our corporate cab services to Matheran are punctual, professional, and invoiced for business use. Choose from executive sedans or SUVs with trained drivers and corporate-grade service standards."
  },
  {
    "name": "Mumbai to Matheran weekend cab",
    "description": "Escape Mumbai with our special weekend cab packages to Matheran. Perfect for last-minute getaways, our weekend cabs come with flexible pickup times, return options, and special rates for round trips. Enjoy nature and unwind in Matheran while we take care of your transport."
  }
],
"tableData": [
  ["Mumbai to Matheran Cab", "-Book cab Mumbai to Matheran"],
  ["One-way taxi Mumbai to Matheran", "-SUV cab hire Mumbai to Matheran"],
  ["AC cab Mumbai to Matheran", "-Mumbai to Matheran sightseeing taxi"],
  ["Chauffeur-driven car Mumbai to Matheran", "-Online cab booking to Matheran from Mumbai"],
  ["Round trip cab Mumbai to Matheran", "-Affordable Mumbai to Matheran taxi"],
  ["Luxury cab Mumbai to Matheran", "-Family cab hire Mumbai to Matheran"],
  ["Premium Matheran cab from Mumbai", "-Corporate cab Mumbai to Matheran"],
  ["Mumbai to Matheran weekend cab", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Matheran Cab Transfers",
    "WhyChoosedescription": "Traveling from Mumbai to Matheran becomes effortless with our reliable cab service. Whether you're planning a peaceful weekend retreat or a short hill station getaway, we ensure timely pickup from your location and smooth coordination throughout the journey. Our cab service is built on punctuality, customer comfort, and hassle-free planning so you can enjoy your trip without stress or delays."
  },
  {
    "WhyChooseheading": "Comfortable and Clean Vehicles for a Scenic Drive",
    "WhyChoosedescription": "The journey to Matheran includes highway driving and a winding uphill approach. Our vehicles are well-maintained, air-conditioned, and designed for comfort on long and curvy routes. With ample legroom, clean interiors, reclining seats, and sufficient luggage space, you can sit back and enjoy the ride through the Western Ghats as you head toward one of Maharashtra’s most serene hill stations."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local and Hill Driving Skills",
    "WhyChoosedescription": "Our professional drivers are familiar with the Mumbai–Neral–Matheran route and are trained to handle ghat sections and narrow roads leading up to Dasturi Point (the last motorable point before entering Matheran). They ensure your journey is not only safe and smooth but also informative and pleasant, offering suggestions on where to stop for views or refreshments en route."
  },
  {
    "WhyChooseheading": "Transparent Pricing – No Hidden Charges",
    "WhyChoosedescription": "With our Mumbai to Matheran cab service, we follow a fully transparent pricing model. Your fare includes fuel, tolls, and driver charges with no hidden costs or last-minute additions. We believe in offering premium service at competitive rates so that you can plan your trip confidently, knowing exactly what you’re paying for from the very beginning."
  },
  {
    "WhyChooseheading": "24/7 Availability to Suit All Travel Schedules",
    "WhyChoosedescription": "Planning an early morning nature trip or returning from Matheran in the evening? Our services are available 24/7 to match your schedule. Whether it’s a weekday retreat or a weekend plan, you can book a cab at any hour. We’re always ready to support your journey with on-demand flexibility and round-the-clock operations."
  },
  {
    "WhyChooseheading": "Quick Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your cab from Mumbai to Matheran is easy and fast. You can book online through our website or app, or call our support team for immediate assistance. You’ll receive instant confirmation, transparent pricing details, and driver contact info—ensuring you’re fully informed and ready to travel with zero guesswork or uncertainty."
  },
  {
    "WhyChooseheading": "Safety-Focused Travel Experience",
    "WhyChoosedescription": "Your safety is a top priority for us. All our vehicles are regularly serviced, sanitized, and equipped with seat belts, GPS tracking, and emergency kits. Our drivers follow all traffic regulations and safe driving practices, especially on hilly routes. Whether you're traveling with kids, elderly passengers, or solo, your journey to Matheran is in safe hands."
  },
  {
    "WhyChooseheading": "Customized Travel Options for a Seamless Experience",
    "WhyChoosedescription": "Every traveler has different needs, and we cater to them all. Whether you need a one-way drop at Dasturi Point, a round trip with waiting time, or help coordinating transport from Neral railway station to Matheran, we offer flexible packages. Our goal is to personalize the experience so that your trip is comfortable, convenient, and memorable from start to finish."
  }
]





    }









const faqData = [
  {
    question: "Can I book a cab from Mumbai to Matheran with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable and convenient cab services from Mumbai to Matheran for tourists and weekend travelers."
  },
  {
    question: "How long does it take to reach Matheran from Mumbai by cab?",
    answer: "The journey typically takes around 2.5 to 3.5 hours depending on traffic and road conditions."
  },
  {
    question: "What vehicle options are available for the Mumbai to Matheran route?",
    answer: "We provide a range of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers for groups and families."
  },
  {
    question: "Can Deva Cabs drop me at Dasturi Naka near Matheran?",
    answer: "Yes, since vehicles are not allowed inside Matheran, our cab will drop you at Dasturi Naka — the closest point accessible by car."
  },
  {
    question: "Is pre-booking available for Mumbai to Matheran cabs?",
    answer: "Yes, you can pre-book your cab easily through our website, mobile app, or by contacting our customer service."
  },
  {
    question: "Are one-way cab services available for this route?",
    answer: "Yes, Deva Cabs offers affordable one-way services from Mumbai to Matheran without return fare charges."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Toll and parking charges are generally extra and will be shared clearly during the booking process."
  },
  {
    question: "Can I book a round-trip cab from Mumbai to Matheran?",
    answer: "Yes, we offer customizable round-trip packages if you plan to return the same day or after a short stay."
  },
  {
    question: "Is your cab service safe for solo and female travelers?",
    answer: "Absolutely. Our drivers are background-verified and trained to ensure a secure and comfortable experience."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Matheran travel?",
    answer: "Deva Cabs offers clean vehicles, professional drivers, punctual service, and transparent pricing for a worry-free journey."
  }
];

const testimonialData = [
  {
    id: 35,
    name: 'Mr. Kunal Shetty',
    role: 'Nature Enthusiast',
    review: 'Deva Cabs dropped us right at Dasturi Naka for our Matheran trip. The car was clean, and the service was top-notch. Will book again!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 36,
    name: 'Ms. Tanya Bhargav',
    role: 'Weekend Traveler',
    review: 'Our Mumbai to Matheran cab ride with Deva Cabs was smooth and punctual. The driver was courteous and knew the route well. Excellent experience!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];







































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Matheran Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-matheran-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Matheran cab with Deva Cabs. Choose from SUV, AC, luxury, and chauffeur-driven cabs for one-way, round trip, sightseeing, family, corporate, and weekend trips. Easy online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1080"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-matheran-cab" // Replace with actual page URL
  }
};






    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Matheran Cab | Affordable & Luxury Taxi Service | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Matheran cab with Deva Cabs. SUV, AC, luxury, and chauffeur-driven cabs available for one-way, round trip, sightseeing, family, corporate, and weekend trips. Easy online booking." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Matheran Cab, Book cab Mumbai to Matheran, One-way taxi Mumbai to Matheran, SUV cab hire Mumbai to Matheran, AC cab Mumbai to Matheran, Mumbai to Matheran sightseeing taxi, Chauffeur-driven car Mumbai to Matheran, Online cab booking to Matheran from Mumbai, Round trip cab Mumbai to Matheran, Affordable Mumbai to Matheran taxi, Luxury cab Mumbai to Matheran, Family cab hire Mumbai to Matheran, Premium Matheran cab from Mumbai, Corporate cab Mumbai to Matheran, Mumbai to Matheran weekend cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitomatherancab;